"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLabel = exports.EventAction = exports.EventCategory = exports.VASTEventIDs = exports.VAST = exports.AdtechRenderer = exports.AdtechProduct = exports.AdtechApplication = exports.AdtechClient = void 0;
// Clients/platforms that we show adverts across wetransfer products
var AdtechClient;
(function (AdtechClient) {
    AdtechClient["Transfer"] = "transfer";
})(AdtechClient = exports.AdtechClient || (exports.AdtechClient = {}));
// Application names
var AdtechApplication;
(function (AdtechApplication) {
    AdtechApplication["desktopWallpaper"] = "desktop-wallpaper";
    AdtechApplication["mobileWeb"] = "mobile-web";
})(AdtechApplication = exports.AdtechApplication || (exports.AdtechApplication = {}));
// Products types that the clients can show adverts on
var AdtechProduct;
(function (AdtechProduct) {
    AdtechProduct["Web"] = "web";
    AdtechProduct["WebMobile"] = "web-mobile";
    AdtechProduct["NativeMobile"] = "native-mobile";
})(AdtechProduct = exports.AdtechProduct || (exports.AdtechProduct = {}));
// Adtech application responsible for the rendering of the advert
var AdtechRenderer;
(function (AdtechRenderer) {
    AdtechRenderer["MobileWebRenderer"] = "mobile-web-renderer";
    // WebRenderer = 'web-renderer',
    AdtechRenderer["MobileIosRenderer"] = "mobile-ios-renderer";
    AdtechRenderer["DesktopWebRenderer"] = "desktop-web-renderer";
})(AdtechRenderer = exports.AdtechRenderer || (exports.AdtechRenderer = {}));
var VAST;
(function (VAST) {
    VAST["Start"] = "start";
    VAST["FirstQuartile"] = "firstQuartile";
    VAST["Midpoint"] = "midpoint";
    VAST["ThirdQuartile"] = "thirdQuartile";
    VAST["Complete"] = "complete";
    VAST["Mute"] = "mute";
    VAST["Unmute"] = "unmute";
    VAST["Pause"] = "pause";
    VAST["Resume"] = "resume";
})(VAST = exports.VAST || (exports.VAST = {}));
// Each VAST event corresponds to a Kevel Custom Event ID
// https://dev.kevel.com/docs/custom-event-tracking#event-id-mapping---named-events
// For video metrics, Kevel uses the following:
exports.VASTEventIDs = {
    start: 70,
    firstQuartile: 71,
    midpoint: 72,
    thirdQuartile: 73,
    complete: 74,
    mute: 75,
    unmute: 76,
    pause: 77,
    resume: 79,
};
var EventCategory;
(function (EventCategory) {
    EventCategory["Click"] = "click";
    EventCategory["Impression"] = "impression";
    EventCategory["Custom"] = "custom";
})(EventCategory = exports.EventCategory || (exports.EventCategory = {}));
var EventAction;
(function (EventAction) {
    EventAction["ClickThrough"] = "clickThrough";
    EventAction["Impression"] = "impression";
})(EventAction = exports.EventAction || (exports.EventAction = {}));
var EventLabel;
(function (EventLabel) {
    EventLabel["StartUpgradeProcess"] = "startUpgradeProcess";
    EventLabel["ImageLoad"] = "imageLoad";
})(EventLabel = exports.EventLabel || (exports.EventLabel = {}));
//# sourceMappingURL=types.js.map